import Modernizr from 'modernizr';

import 'formvalidation/src/js/base';
import 'formvalidation/src/js/helper';
import 'formvalidation/src/js/framework/bootstrap';
import 'formvalidation/src/js/validator/notEmpty';

export default class ValidateMessageForm {
  constructor(elem) {
    this.form = elem;

    this.framework = 'bootstrap';
    this.trigger = 'blur';
    this.breakpoint = this._getBreakpoint();
    this.fields = this._getFieldsToValidate();
    this.icons = this._getIcons();

    this.init();
  }

  init() {
    if (this.breakpoint === 'screen-sm') {
      this._validateForm(this._getValidationObject());
    } else {
      this._validateFormWithTooltip(
        this._getValidationObject({
          err: {
            container: 'tooltip'
          }
        })
      );
    }
  }

  _validateForm(obj) {
    $(this.form)
      .formValidation(obj)
      .on('success.form.fv', e => {
        // Prevent form submission
        e.preventDefault();
        this._processForm(e);
      });
  }

  _validateFormWithTooltip(obj) {
    $(this.form)
      .formValidation(obj)
      .on('err.field.fv', (e, data) => {
        const $input = data.element[0];
        const placement = $input.getAttribute('data-fv-tooltip-placement');
        const $icon = data.element.data('fv.icon');
        const title = $icon.data('bs.tooltip').getTitle();

        $icon.tooltip('destroy');

        data.element.tooltip({
          html: true,

          placement,

          template:
            '<div class="tooltip tooltip--error" role="tooltip"><div class="tooltip-arrow tooltip__arrow--error"></div><div class="tooltip-inner tooltip__inner--error"></div></div>',

          title,

          container: 'body'
        });
      })
      .on('success.field.fv', (e, data) => {
        data.element.tooltip('destroy');
      })
      .on('success.form.fv', e => {
        // Prevent form submission
        e.preventDefault();

        this._processForm(e);
      });
  }

  /* eslint-disable class-methods-use-this */
  _processForm(e) {
    const $form = $(e.target);
    const formData = new FormData();
    const params = $form.serializeArray();
    // const { files } = $form.find('[name="uploadedFiles"]')[0].files;
    // const { files } = $('input[name="uploadedFiles"]')[0].files;
    // console.log('input[name="uploadedFiles"');
    // console.log($('input[name="uploadedFiles"]')[0].files);
    // console.log('files');
    // console.log(files);

    const $alert = $('#message-box-pn');
    //  const $alertSuccessTitle = $alert.attr('data-info-title');
    const $alertSuccessTitle = $alert.attr('');
    //  const $alertDangerTitle = $alert.attr('data-info-title');
    const $alertDangerTitle = $alert.attr('');

    // $.each($('input[name="uploadedFiles"]')[0].files, (i, file) => {
    // Prefix the name of uploaded files with "uploadedFiles-"
    // formData.append(`uploadedFiles-${i}`, file);
    // });

    $.each(params, (i, val) => {
      formData.append(val.name, val.value);
      if (val.name === 'recipient_id') {
        this.recipient_id = val.value;
      }
    });

    const request = $.ajax({
      beforeSend: () => {
        $('#js-loader').show();
      },
      cache: false,

      contentType: false,

      processData: false,

      url: $form.attr('action'),

      type: 'POST',

      data: formData
    });
    // console.log(request);
    request.done(response => {
      // console.log(response);
      const $formGroup = $form.find('.form-group');
      const $formGroupIcon = $formGroup.find('i');
      const $submitBtn = $form.find('[type=submit]');
      if (response.type === 'info') {
        // Remove the has-success class
        $formGroup.removeClass('has-success');
        // Hide the success icon
        $formGroupIcon.hide();
        // Activate Button
        $submitBtn.removeClass('disabled');
        $submitBtn.attr('disabled', false);
        // Reset form
        $form[0].reset();
        // Show success message
        $alert.find('p:first-child').text($alertSuccessTitle);
        $alert.find('p:last-child').text(response.MESSAGE);
        $alert.removeClass('alert-danger');
        $alert.addClass('alert-success');
        $alert.slideDown();
        setTimeout(() => {
          $alert.slideUp();
          $alert.removeClass('alert-success');
          $alert.find('p:first-child').html('');
          $alert.find('p:last-child').html('');
        }, 6000);
        document.querySelector('#queue').innerHTML = '';
        document.querySelector('#uploadifive-uploadifive').style.display = '';
        // window.location.href = `/profile.php?id=${this.recipient_id}&n=1`;
      } else {
        // Remove the has-success class
        $formGroup.removeClass('has-success');
        // Hide the success icon
        $formGroupIcon.hide();
        // Activate Button
        $submitBtn.removeClass('disabled');
        $submitBtn.attr('disabled', false);
        // Reset form
        // $form[0].reset();
        // Show danger message
        $alert.find('p:first-child').text($alertDangerTitle);
        $alert.find('p:last-child').html(response.MESSAGE);
        $alert.removeClass('alert-success');
        $alert.addClass('alert-danger');
        $alert.slideDown();
        setTimeout(() => {
          $alert.slideUp();
          $alert.removeClass('alert-danger');
          $alert.find('p:first-child').html('');
          $alert.find('p:last-child').html('');
        }, 6000);
      }
    });

    request.fail((jqXHR, textStatus) => {
      // Show error message
      $alert.show(textStatus);
    });

    request.always(() => {
      $('#js-loader').hide();
    });
  }

  _getIcons() {
    const icons = {
      valid: 'fa fa-check',

      invalid: 'fa fa-times',

      validating: 'fa fa-refresh'
    };

    return icons;
  }

  _getBreakpoint() {
    let breakpoint;

    if (Modernizr.mq('(min-width: 992px)')) {
      breakpoint = 'screen-lg';
    } else if (Modernizr.mq('(min-width: 768px)')) {
      breakpoint = 'screen-md';
    } else {
      breakpoint = 'screen-sm';
    }

    return breakpoint;
  }
  /* eslint-enable class-methods-use-this */

  _getFieldsToValidate() {
    const fields = {
      subject: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.form)
              .find('[name=subject]')
              .attr('data-fv-notempty-message')
          }
        }
      },

      message: {
        verbose: false,

        validators: {
          notEmpty: {
            message: $(this.form)
              .find('[name=message]')
              .attr('data-fv-notempty-message')
          }
        }
      }
    };

    return fields;
  }

  _getValidationObject({
    framework = this.framework,
    icon = this.icons,
    fields = this.fields,
    trigger = this.trigger,
    err
  } = {}) {
    const object = {
      framework,
      icon,
      fields,
      trigger,
      err
    };

    return object;
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/validate_message_form.js